import { initializeApp } from 'firebase/app';

// const firebaseConfig = {
//   apiKey: 'AIzaSyAvUMz5vKq0r81BpsjK-gtncYtftGoYQSI',
//   authDomain: 'project-nta.firebaseapp.com',
//   projectId: 'project-nta',
//   storageBucket: 'project-nta.appspot.com',
//   messagingSenderId: '367250764364',
//   appId: '1:367250764364:web:381e8745095c6d537f7ae9',
//   measurementId: 'G-V99C2HRW5H',
// };
const firebaseConfig = {
  apiKey: "AIzaSyAk4arU8ihVQvII-2ee-Bc1FJltshut-90",
  authDomain: "nta-user.firebaseapp.com",
  projectId: "nta-user",
  storageBucket: "nta-user.appspot.com",
  messagingSenderId: "1024802870737",
  appId: "1:1024802870737:web:685bd9453ebf01c5873cf0"
};

const firebase = initializeApp(firebaseConfig);
export default firebase;